import type { MapOptions } from 'mapbox-gl';
import { GEOGRAPHIC_CH_BBOX } from '../geographic-values';

export const CH_DEFAULT_MAP_OPTIONS: MapOptions = {
  container: 'map-container',
  style: 'mapbox://styles/mapbox/streets-v12',
  bounds: GEOGRAPHIC_CH_BBOX,
  preserveDrawingBuffer: true,
  cooperativeGestures: true,
  locale: {
    'ScrollZoomBlocker.CtrlMessage':
      'Nutzen Sie ctrl + scroll, um in der Karte zu zoomen',
    'ScrollZoomBlocker.CmdMessage':
      'Nutzen Sie ⌘ + scroll, um in der Karte zu zoomen',
    'TouchPanBlocker.Message': 'Nutzen Sie 2 Finger, um in der Karte zu zoomen',
  },
};
